const colorProjection: { [key: string]: string } = {
  "Conference": "#085EC0",
  "Journal": "#5349E0",
  "Workshop": "#5B8FF9",
  "arXiv": "#B31B1B",
  "Pending": "#907BFF",
  "Competition": "#8C1104",
  "Course": "#006C6C",
  "Research": "#B85C00",
  "Other": "#99ADD1",
};

export default colorProjection;
